import * as React from "react";
import { Typography } from "@mui/material";
 
interface SuperScriptStrProps {
    text: string,
    sup: string,
    style?: Object,
    textSize?: string,
    supSize?: string,
}

const SuperScriptStr: React.FC<SuperScriptStrProps> = ({ text, sup, style, textSize, supSize }) => {
  return (
    <Typography
        component={"span"}
        sx={style}
    >
        <span style={{fontSize: `${textSize ? textSize : '24px'}`}}>{text}</span>
        <span style={{ marginLeft: "5px", fontSize: `${supSize ? supSize : '18px'}`, color: "#c1c1c1" }}>{sup}</span>
    </Typography>

  );
};

export default SuperScriptStr;